"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _ConnectInbox = _interopRequireDefault(require("InboxConnectUtils/ConnectInbox"));

var _constants = require("composer-lib/lib/constants");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _GoogleDocs = _interopRequireDefault(require("composer-lib/data/model/GoogleDocs"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var ModalAboveGooglePicker = (0, _styledComponents.default)(_UIModal.default).withConfig({
  displayName: "GoogleAccountSwitcher__ModalAboveGooglePicker",
  componentId: "rirzk0-0"
})(["z-index:", " !important;"], _constants.Z_INDEX_ABOVE_GOOGLE_PICKER);

var _default = (0, _createReactClass.default)({
  displayName: "GoogleAccountSwitcher",
  mixins: [_ComponentWithPartials.default, _reactAddonsPureRenderMixin.default],
  propTypes: {
    googleDocs: _propTypes.default.instanceOf(_GoogleDocs.default).isRequired,
    fetchGoogleAccounts: _propTypes.default.func.isRequired,
    hideGoogleAccountSwitcher: _propTypes.default.func.isRequired,
    hideGoogleDocsPicker: _propTypes.default.func.isRequired,
    showGoogleAuthError: _propTypes.default.func.isRequired,
    uiSettings: _propTypes.default.instanceOf(_UISettings.default).isRequired,
    updateGoogleAccount: _propTypes.default.func.isRequired,
    updateNewGoogleAccount: _propTypes.default.func.isRequired
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props = this.props,
        fetchGoogleAccounts = _this$props.fetchGoogleAccounts,
        uiSettings = _this$props.uiSettings;

    if (!uiSettings.showGoogleAccountSwitcher && nextProps.uiSettings.showGoogleAccountSwitcher) {
      fetchGoogleAccounts();
    }
  },
  handleAccountChange: function handleAccountChange(account) {
    var _this$props2 = this.props,
        hideGoogleAccountSwitcher = _this$props2.hideGoogleAccountSwitcher,
        updateGoogleAccount = _this$props2.updateGoogleAccount;
    hideGoogleAccountSwitcher();
    updateGoogleAccount(account);
  },
  handleNewAccountClick: function handleNewAccountClick() {
    var _this$props3 = this.props,
        hideGoogleAccountSwitcher = _this$props3.hideGoogleAccountSwitcher,
        hideGoogleDocsPicker = _this$props3.hideGoogleDocsPicker;
    hideGoogleAccountSwitcher();
    hideGoogleDocsPicker();
    this.showGoogleAuth();
  },
  showGoogleAuth: function showGoogleAuth() {
    var _this$props4 = this.props,
        showGoogleAuthError = _this$props4.showGoogleAuthError,
        updateNewGoogleAccount = _this$props4.updateNewGoogleAccount;

    _ConnectInbox.default.connectWithOptions({
      requestGroup: _constants.CONNECT_INBOX_REQUEST_GROUP,
      portalId: _PortalIdParser.default.get()
    }).then(function (resp) {
      return updateNewGoogleAccount(resp.payload.emailAddress);
    }, showGoogleAuthError);
  },
  renderAccount: function renderAccount(account, index) {
    return _react.default.createElement("div", {
      key: index
    }, _react.default.createElement(_UILink.default, {
      className: "display-block p-y-3",
      onClick: this.partial(this.handleAccountChange, account)
    }, account.email), _react.default.createElement(_HR.default, {
      distance: "flush"
    }));
  },
  renderAccountList: function renderAccountList() {
    var _this$props$googleDoc = this.props.googleDocs,
        accounts = _this$props$googleDoc.accounts,
        accountsRequestStatus = _this$props$googleDoc.accountsRequestStatus;

    if (accountsRequestStatus === _constants.RequestStatus.PENDING) {
      return _react.default.createElement(_UILoadingSpinner.default, {
        grow: true
      });
    }

    if (accounts.size === 0) {
      return null;
    }

    return _react.default.createElement(_UIList.default, {
      className: "p-top-2"
    }, accounts.map(this.renderAccount));
  },
  render: function render() {
    var _this$props5 = this.props,
        hideGoogleAccountSwitcher = _this$props5.hideGoogleAccountSwitcher,
        uiSettings = _this$props5.uiSettings;

    if (!uiSettings.showGoogleAccountSwitcher) {
      return null;
    }

    return _react.default.createElement(ModalAboveGooglePicker, null, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
      onClick: hideGoogleAccountSwitcher
    }), _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.googleAccountSwitcher.header"
    }))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.googleAccountSwitcher.body"
    }), this.renderAccountList(), _react.default.createElement(_UILink.default, {
      className: "display-block p-top-3 p-bottom-6",
      onClick: this.handleNewAccountClick
    }, _react.default.createElement(_UIIcon.default, {
      name: "contacts"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.googleAccountSwitcher.selectDifferentAccount"
    }))));
  }
});

exports.default = _default;
module.exports = exports.default;